import React from "react";
import { Button } from "@clayui/core";

interface SubmitButtonProps {
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  style?: React.CSSProperties;
  label: string;
  disable?:boolean
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  onClick,
  type = "submit", // default to 'submit' if not provided
  style,
  label,
  disable
}) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      className="submit-btn-primary"
      disabled={disable}
      style={{ width: '100%',padding:"8px 12px" }}
    >
      {label}
    </Button>
  );
};

export default SubmitButton;
